import gql from "graphql-tag";

export default gql`
  query getItemsByShopId($id: String!, $nextToken: String, $limit: Int!) {
    getItemsByShopId(id: $id, nextToken: $nextToken, limit: $limit) {
      nextToken
      items {
        itemId,
        title,
        description,
        price,
        images,
        category,
        shopId,
        status,
        city,
        countryCode,
        shopPhone,
        shopName
      }
    }
  }
`;
